var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, ViewChild, Input } from '@angular/core';
import * as _ from 'lodash';
import { IndicatorLightType } from '../../diagram/utils/indicator-light/indicator-light-type';
import { SwitchHelper } from '../../diagram/utils/switch/switch-helper';
import { IndicatorLightHelper } from '../../diagram/utils/indicator-light/indicator-light-helper';
import { ResizableElementSettingModal } from '../base/resizable-element-setting-modal';
import { SecuritySettingAdapter } from '../shared/control/security-setting.adapter';
import { DynamicDisplayModel } from '../../../../shared/dynamic-conduct-model/dynamic-display/dynamic-display-model';
var SwitchIndicatorLightSettingModalComponent = /** @class */ (function (_super) {
    __extends(SwitchIndicatorLightSettingModalComponent, _super);
    function SwitchIndicatorLightSettingModalComponent(injector) {
        return _super.call(this, injector, 'switchIndicatorLightSettingModal') || this;
    }
    SwitchIndicatorLightSettingModalComponent.prototype.init = function (editedComponent) {
        var _this = this;
        this.editedComponent = editedComponent;
        _super.prototype.init.call(this, editedComponent);
        this.configureId = editedComponent.configureId;
        var componentData = editedComponent.model.data;
        this.loadBasicInfo(componentData);
        this.loadStateSettings(componentData);
        this.loadGraphSetting(componentData);
        this.loadControlSetting(componentData);
        this.loadDynamicSetting(componentData);
        setTimeout(function () {
            _this.displaySettingCmp.init(editedComponent);
            _this.enableSettingCmp.init(editedComponent);
        }, 500);
    };
    SwitchIndicatorLightSettingModalComponent.prototype.loadBasicInfo = function (componentData) {
        this.useSwitch = !!componentData.useSwitch;
        if (this.useSwitch && null != componentData.switchSettings) {
            this.switchSettings = _.cloneDeep(componentData.switchSettings);
        }
        else {
            this.switchSettings = SwitchHelper.getDefaultSwitchSettings();
        }
        this.useIndicatorLight = !!componentData.useIndicatorLight;
        if (this.useIndicatorLight && null != componentData.indicatorLightSettings) {
            this.indicatorLightSettings = _.cloneDeep(componentData.indicatorLightSettings);
        }
        else {
            this.indicatorLightSettings = IndicatorLightHelper.getDefaultIndicatorLightSettings();
        }
    };
    SwitchIndicatorLightSettingModalComponent.prototype.loadStateSettings = function (componentData) {
        this.stateSettings = {};
        var componentStates = _.cloneDeep(componentData.states);
        if (this.useIndicatorLight) {
            if (!this.indicatorLightSettings.type) {
                this.indicatorLightSettings.type = IndicatorLightType.Bit;
            }
            if (IndicatorLightType.Bit === this.indicatorLightSettings.type) {
                this.stateSettings.bitIndicatorLightStates = componentStates;
            }
            else {
                this.stateSettings.wordIndicatorLightStates = componentStates;
            }
        }
        else {
            this.stateSettings.switchStates = componentStates;
        }
        if (!this.stateSettings.bitIndicatorLightStates) {
            this.stateSettings.bitIndicatorLightStates = IndicatorLightHelper.getDefaultBitIndicatorLightStates();
        }
        if (!this.stateSettings.wordIndicatorLightStates) {
            this.stateSettings.wordIndicatorLightStates = IndicatorLightHelper.getDefaultWordIndicatorLightStates();
        }
        if (!this.stateSettings.switchStates) {
            this.stateSettings.switchStates = SwitchHelper.getDefaultSwitchStates();
        }
    };
    SwitchIndicatorLightSettingModalComponent.prototype.loadGraphSetting = function (componentData) {
        this.useGraph = componentData.useGraph;
        if (null != componentData.graphSetting) {
            this.graphSetting = _.cloneDeep(componentData.graphSetting);
        }
        else {
            this.graphSetting = {};
        }
    };
    SwitchIndicatorLightSettingModalComponent.prototype.loadDynamicSetting = function (componentData) {
        if (null != componentData.dynamicSetting) {
            this.dynamicSetting = _.cloneDeep(componentData.dynamicSetting);
            DynamicDisplayModel.addDefaultForRotationTranslation(this.dynamicSetting);
        }
        else {
            this.dynamicSetting = DynamicDisplayModel.default();
        }
    };
    SwitchIndicatorLightSettingModalComponent.prototype.loadControlSetting = function (componentData) {
        this.securitySettingData = new SecuritySettingAdapter(componentData, true);
    };
    SwitchIndicatorLightSettingModalComponent.prototype.saveSwitchSettings = function () {
        this.saveComponentProperty('useSwitch', this.useSwitch);
        if (this.useSwitch) {
            this.saveComponentProperty('switchSettings', this.switchSettings);
        }
        else {
            this.deleteComponentProperty('switchSettings');
        }
    };
    SwitchIndicatorLightSettingModalComponent.prototype.saveIndicatorLightSettings = function () {
        this.saveComponentProperty('useIndicatorLight', this.useIndicatorLight);
        if (this.useIndicatorLight) {
            this.saveComponentProperty('indicatorLightSettings', this.indicatorLightSettings);
        }
        else {
            this.deleteComponentProperty('indicatorLightSettings');
        }
    };
    SwitchIndicatorLightSettingModalComponent.prototype.saveStates = function () {
        if (this.useIndicatorLight) {
            if (IndicatorLightType.Bit === this.indicatorLightSettings.type) {
                this.saveComponentProperty('states', this.stateSettings.bitIndicatorLightStates);
            }
            else {
                this.saveComponentProperty('states', this.stateSettings.wordIndicatorLightStates);
            }
        }
        else {
            this.saveComponentProperty('states', this.stateSettings.switchStates);
        }
    };
    SwitchIndicatorLightSettingModalComponent.prototype.saveGraphSetting = function () {
        this.saveComponentProperty('useGraph', this.useGraph);
        if (this.useGraph) {
            this.saveComponentProperty('graphSetting', this.graphSetting);
        }
        else {
            this.deleteComponentProperty('graphSetting');
        }
        this.deleteComponentProperty('graphUrl');
    };
    SwitchIndicatorLightSettingModalComponent.prototype.saveControlSetting = function () {
        this.controlSettingCmp.save(this.editedComponent.model, this.useSwitch);
    };
    SwitchIndicatorLightSettingModalComponent.prototype.saveDynamicSetting = function () {
        if (!this.dynamicValidatoinResult) {
            if (this.dynamicSetting.isTranslation !== true) {
                this.dynamicSetting.horizontalTranslation = null;
                this.dynamicSetting.verticalTranslation = null;
            }
            else {
                if (this.dynamicSetting.isHorizontalTranslation !== true) {
                    this.dynamicSetting.horizontalTranslation = null;
                }
                if (this.dynamicSetting.isVerticalTranslation !== true) {
                    this.dynamicSetting.verticalTranslation = null;
                }
            }
            if (this.dynamicSetting.isRotation !== true) {
                this.dynamicSetting.rotation = null;
            }
            this.saveComponentProperty('dynamicSetting', this.dynamicSetting);
        }
        else {
            this.notify.error(this.l('Savedfail'));
        }
    };
    SwitchIndicatorLightSettingModalComponent.prototype.save = function () {
        this.saving = true;
        this.currentDiagram.startTransaction('switchIndicatorLight settings');
        if (this.useSwitch) {
            if (!this.enableSettingCmp.save()) {
                this.saving = false;
                this.setActiveTab(4);
                return;
            }
        }
        if (!this.displaySettingCmp.save()) {
            this.saving = false;
            this.setActiveTab(5);
            return;
        }
        this.saveSwitchSettings();
        this.saveIndicatorLightSettings();
        this.saveStates();
        this.saveGraphSetting();
        this.saveControlSetting();
        this.saveDynamicSetting();
        this.currentDiagram.commitTransaction('switchIndicatorLight settings');
        this.close();
    };
    SwitchIndicatorLightSettingModalComponent.prototype.validateChange = function (validatoinResult) {
        this.dynamicValidatoinResult = validatoinResult;
    };
    SwitchIndicatorLightSettingModalComponent.prototype.setActiveTab = function (tabId) {
        this.staticTabs.tabs[tabId].active = true;
    };
    SwitchIndicatorLightSettingModalComponent.prototype.switchBitIndexChange = function () {
        this.switchSaving = this.basicInfoCmp.isSwitchBitIndexWithinScope();
    };
    SwitchIndicatorLightSettingModalComponent.prototype.lightBitIndexChange = function () {
        this.lightSaving = this.basicInfoCmp.isLightBitIndexWithinScope();
    };
    __decorate([
        ViewChild('displaySettingCmp', { static: false })
    ], SwitchIndicatorLightSettingModalComponent.prototype, "displaySettingCmp", void 0);
    __decorate([
        ViewChild('enableSettingCmp', { static: false })
    ], SwitchIndicatorLightSettingModalComponent.prototype, "enableSettingCmp", void 0);
    __decorate([
        ViewChild('staticTabs', { static: false })
    ], SwitchIndicatorLightSettingModalComponent.prototype, "staticTabs", void 0);
    __decorate([
        ViewChild('controlSettingCmp', { static: false })
    ], SwitchIndicatorLightSettingModalComponent.prototype, "controlSettingCmp", void 0);
    __decorate([
        ViewChild('basicInfoCmp', { static: false })
    ], SwitchIndicatorLightSettingModalComponent.prototype, "basicInfoCmp", void 0);
    __decorate([
        Input()
    ], SwitchIndicatorLightSettingModalComponent.prototype, "viewWidth", void 0);
    __decorate([
        Input()
    ], SwitchIndicatorLightSettingModalComponent.prototype, "viewHeight", void 0);
    SwitchIndicatorLightSettingModalComponent = __decorate([
        Component({
            selector: 'switch-indicator-light-setting-modal',
            styles: [".mt-checkbox-outline { margin-bottom: 5px } .padding-top-10 { padding-top: 10px; } .labelWidth { width: 180px; } .variable-combo-padding { padding-top: 6px; padding-bottom: 6px; } .radio-title { font-size: 14px; color: #333333; } .warn-color { color: red; margin-left: 105px; } .bitwise-label { width: 100px; } .bitwise-variable { width: calc(100% - 205px); } .bitwise-bitIndex { width: 90px; } .point { height: 30px; float: left; width: 10px; text-align: center; } .design-nav-link { .nav.nav-tabs { .nav-link { color: #666 !important; border-bottom: 1px solid transparent; } .active{ border-color: #fff; color: #3695ff !important; border-bottom: 1px solid #3695ff; } } }",
                ".element-setting-base{ .inline-label { margin: 10px 0px 0px 10px; display: inline-block; } .border-group { // border: 1px solid #ddd; padding: 5px; margin-bottom: 0px; } .inline-selector { display: inline-block; margin: 5px 0px; } .inline-variable { display: inline-block; margin: 5px 0px; } .inline-input { display: inline-block; margin: 5px 0px; }     } .date-time-setting-modal { .modal-content { width: 600px; } .cursor-pointer{ cursor: pointer; } .recode-input{ width: calc(100% - 70px); border: 1px solid #d7dbe5;   padding:  5px 10px; } textarea.noResize { resize: none; } } .toggleViewSettingModal { .modal-content { width: 600px; } } .textSettingModal { .modal-content { width: 600px; } } "],
            template: "<div bsModal #settingModal=\"bs-modal\" id=\"switchIndicatorLightSettingModal\" class=\"modal fade switchIndicatorLightSettingModal\" tabindex=\"-1\" aria-labelledby=\"settingModal\" aria-hidden=\"true\" (onHidden)=\"onHidden()\" [config]=\"{backdrop: 'static'}\"> <div class=\"modal-dialog\" style=\"min-width: 600px;\"> <div class=\"modal-content\"> <div class=\"fe-modal-container \"> <form class=\"configure\" *ngIf=\"active\" #switchIndicatorLightSettingForm=\"ngForm\" novalidate (ngSubmit)=\"save()\"> <div class=\"modal-header fe-modal-header\"> <div class=\"fe-modal-header-title\"> {{lc(\"SwitchIndicatorLight\")}} </div> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"top-line\"></div> <div class=\"fe-modal-middle design-nav-link\"> <tabset #staticTabs class=\"tab-container tabbable-line\"> <tab heading=\"{{lc('SwitchIndicatorLight')}}\" customClass=\"m-tabs__item\"> <switch-indicator-light-basic-info #basicInfoCmp [(useSwitch)]=\"useSwitch\" [switchSettings]=\"switchSettings\" [(useIndicatorLight)]=\"useIndicatorLight\" [indicatorLightSettings]=\"indicatorLightSettings\" [configureId]='configureId' (switchVariableChangeEvent)=\"switchBitIndexChange()\" (switchBitIndexChangeEvent)=\"switchBitIndexChange()\" (lightBitIndexChangeEvent)=\"lightBitIndexChange()\" (lightVariableChangeEvent)=\"lightBitIndexChange()\"></switch-indicator-light-basic-info> </tab> <tab heading=\"{{lc('State')}}\" customClass=\"m-tabs__item\"> <state *ngIf=\"indicatorLightSettings\" [useSwitch]=\"useSwitch\" [useIndicatorLight]=\"useIndicatorLight\" [indicatorLightType]=\"indicatorLightSettings.type\" [stateSettings]=\"stateSettings\"></state> </tab> <tab heading=\"{{lc('Graph')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(graphSettingEventName)\"> <graph-setting [configureId]=\"configureId\" [(useGraph)]=\"useGraph\" [graphSetting]=\"graphSetting\"></graph-setting> </tab> <tab heading=\"{{lc('DynamicSetting')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(dynamicSettingEventName,configureId)\"> <dynamic-conduct [dynamicSetting]=\"dynamicSetting\" [configureId]='configureId' [viewWidth]=\"viewWidth\" [viewHeight]=\"viewHeight\" (validateChange)=\"validateChange($event);\"></dynamic-conduct> </tab> <tab heading=\"{{lc('ControlSetting')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\" [disabled]=\"!useSwitch\"> <enable-setting #enableSettingCmp></enable-setting> <control-setting #controlSettingCmp [data]=\"securitySettingData\"></control-setting> </tab> <tab heading=\"{{lc('Display')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <display-setting #displaySettingCmp [isFixedPositionVisible]='true'></display-setting> </tab> </tabset> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!switchIndicatorLightSettingForm.form.valid || dynamicValidatoinResult || saving || switchSaving || lightSaving\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\">{{l(\"Save\")}}</button> <button type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\">{{l(\"Cancel\")}}</button> </div> </div> </form> </div> </div> </div> </div>"
        })
    ], SwitchIndicatorLightSettingModalComponent);
    return SwitchIndicatorLightSettingModalComponent;
}(ResizableElementSettingModal));
export { SwitchIndicatorLightSettingModalComponent };
